const BASE_PATH = process.env.base_path;
const ENV = (typeof window !== "undefined" && window.BARKODER_ENV) || process.env.ENV || "live";
const HOME_URL = (typeof window !== "undefined" && window.home_url) || process.env.home_url || process.env.HOME_URL || "/";
const WEB_USERNAME = process.env.WEB_USERNAME;
const WEB_PASS = process.env.WEB_PASS;
const ASSETS_URL = process.env.ASSETS_URL;

const recaptcha_site_key = process.env.recaptcha_site_key
const ALL_SYMOBOLIES = {
    'AZTEC' 		: 'Aztec Code',
    'CODABAR' 		: 'Codabar',
    'CODE11'		: 'Code 11',
    'CODE25'		: 'Code 25',
    'CODE39' 		: 'Code 39 / Code 32',
    'CODE93' 		: 'Code 93',
    'CODE128'		: 'Code 128',
    'DATABAR'		: 'Databar',
    'DATAMATRIX'	: 'Data Matrix',
	'DOTCODE'		: 'DotCode',
    'EANUPC' 		: 'EAN & UPC',
	'MaxiCode' 	 	: 'MaxiCode',
    'MSI' 			: 'MSI Plessey',
    'PDF417'		: 'PDF417',
    'QR' 			: 'QR Code',
	'TELEPEN'		: 'Telepen',
	'MRZ'			: 'MRZ',
	'VIN'			: 'Vin',
	'POSTAL' 		: 'Postal',
}

const LIST_PLATFORM = {
	"ANDROID"	: "Android",
	"IOS" 	 	: "iOS",
	"LINUX"		: "Linux",
	"OSX"		: "OS X",
	"WINDOWS"	: "Windows (DLL)", 
	"WASM"		: "WASM",
}


const BITMASK_TO_PLATFORM = {
	0x00000000 : "0",
	0x00000001 : "ANDROID",
	0x00000002 : "IOS",
	0x00000004 : "LINUX",
	0x00000008 : "OSX",
	0x00000010 : "WINDOWS", //16
	0x00000020 : "WASM", //32
}

export {
	BASE_PATH,
	ENV,
	HOME_URL,
	WEB_USERNAME,
	WEB_PASS,
	ASSETS_URL,
	recaptcha_site_key,
	ALL_SYMOBOLIES,
	LIST_PLATFORM,
	BITMASK_TO_PLATFORM,
};
